import { MessageBar } from '@fluentui/react';
import * as React from 'react';
import { IEvent } from '../../../Models/Event/IEvent';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IOrder } from '../../../Models/Order/IOrder';
import { NewOrderConfirmationView } from './NewOrderConfirmationView';

interface INewOrderConfirmationProps {
    order?: IOrder
    statusMessage?: IStatusMessage
    isAuth: boolean;
    event?: IEvent;
}


export const NewOrderConfirmation: React.FunctionComponent<INewOrderConfirmationProps> = (props) => {

    return (
        <>
            {props.order ?
                <NewOrderConfirmationView isAuth={props.isAuth} order={props.order} event={props.event} /> :
                <MessageBar messageBarType={props.statusMessage?.type}>{props.statusMessage?.message} </MessageBar>
            }
       </>

    )
}
